<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCRow :title="h3" :row="row" />
  </div>
</template>

<script>
import FCRow from "@/components/patterns/FCRow";
export default {
  components: {
    FCRow
  },
  mounted() {
    const ref = this.$store.state.menu.history.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.history.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.history.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "History",
      h3: "Club Philosophy",
      row: [
        {
          image: "box-winning.jpg",
          label: "Winning"
        },
        {
          image: "box-family.jpg",
          label: "Family-Friendly"
        },
        {
          image: "box-community.jpg",
          label: "Community Engagement"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-philosophy.jpg");
  background-size: cover;
  background-position: center;
}
</style>